import { render, staticRenderFns } from "./DetailLaporanBpkbMacet.vue?vue&type=template&id=03027378&"
import script from "./DetailLaporanBpkbMacet.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanBpkbMacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports